/**
 * PreviewCheckoutStep — inert Draft Builder adapter for the details step.
 *
 * Renders CustomerInfoPaymentView (same presentation as production).
 * No Stripe, Turnstile, tips, form writes, or payment intents.
 */

import React from 'react';
import { CustomerInfoPaymentView } from '@/components/booking-shared/CustomerInfoPaymentView';
import type { DraftService } from '@/types/draft';

interface PreviewCheckoutStepProps {
  service: DraftService;
}

const emptyField = { value: '' };

export default function PreviewCheckoutStep({ service }: PreviewCheckoutStepProps) {
  return (
    <CustomerInfoPaymentView
      readOnly
      firstName={emptyField}
      lastName={emptyField}
      email={emptyField}
      phone={emptyField}
      specialRequests={emptyField}
      paymentMethod="new_card"
      cardPaymentsEnabled
      selectedService={{
        name: service.name,
        duration: service.duration,
        price: service.price,
      }}
      tipAmount={0}
      // Intentionally omit tipSection / paymentSection / turnstile — no backends
      showMarketingCheckbox
      marketingChecked={false}
      cancellationPolicy={null}
      footerNotice={
        <div
          style={{
            textAlign: 'center',
            fontSize: 11.5,
            color: 'var(--f-ink-faint, rgba(28,18,12,0.40))',
            lineHeight: 1.5,
            padding: '16px 8px 0',
          }}
        >
          Preview experience — no payment will be processed
        </div>
      }
    />
  );
}
